import React from 'react';

// Architectural background with building image and white overlay
const dashboardBackgroundStyles = `
.dashboard-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background: url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=2070') center/cover no-repeat fixed;
}

.dashboard-bg::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* Raise the alpha to fade the building image further back; lower it to bring it forward. */
  background: rgba(255, 255, 255, 0.92);
  pointer-events: none;
  z-index: 0;
}

.dashboard-bg > * {
  position: relative;
  z-index: 1;
}
`;

// Immediately inject styles
const injectDashboardStyles = () => {
  const styleId = 'dashboard-background-styles';
  if (typeof document !== 'undefined' && !document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = dashboardBackgroundStyles;
    document.head.appendChild(style);
  }
};

// Call immediately
injectDashboardStyles();

export const AnimatedBackground: React.FC = () => {
  return null; // Background is applied via CSS on .dashboard-bg
};
